import axios from 'axios';
import url from '../../utils/url';

export default {
  namespaced: true,
  state: {
    recordings: [],
    total: 0,
    channelData: [],
    dateRange: [],
    device_id: null,
  },
  getters: {
    recordings: state => state.recordings.filter(r => r.device_id === state.device_id),
    total: state => state.recordings.length,
    channelData: state => state.channelData,
    currentDateRange: state => state.dateRange,
    device_id: state => state.device_id,
  },
  actions: {
    // fetch past recordings
    async fetchMissingPastRecordings({ commit }, payLoad) {
      const response = await axios.get(url`/api/v1/accounts/${payLoad.account}/devices/${payLoad.device}/recordings?from=${payLoad.from}&to=${payLoad.to}&sourceRoute=detailViewRecordings`);
      commit('mergeRecordings', response.data.recordings);
      commit('mergeChannelData', response.data.channels);
    },
    // fetch future recordings
    async fetchMissingFutureRecordings({ commit }, payLoad) {
      const response = await axios.get(url`/api/v1/accounts/${payLoad.account}/devices/${payLoad.device}/recordings?from=${payLoad.from}&to=${payLoad.to}&sourceRoute=detailViewRecordings`);
      commit('mergeRecordings', response.data.recordings);
      commit('mergeChannelData', response.data.channels);
    },
  },
  mutations: {
    mergeRecordings(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.recordings = [...new Set([...state.recordings, ...data])];
      state.recordings.sort((a, b) => a.timestamp - b.timestamp).reverse();
    },
    mergeChannelData(state, data) {
      Object.entries(data)
        .forEach(([channel, channelData]) => {
          Object.entries(channelData)
            .forEach(([key, dataCollection]) => {
              dataCollection.forEach(item => {
                state.channelData[channel][key].push(item);
              });
            });
        });
    },
    setRecordings(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.recordings = data;
    },
    setChannelData(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.channelData = data;
    },
    setTotal(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.total = data;
    },
    setDateRange(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.dateRange = data;
    },
    setDeviceId(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.device_id = data;
    },
    clearRecordings(state) {
      // eslint-disable-next-line no-param-reassign,no-unused-vars
      state = {
        recordings: [],
        total: 0,
        channelData: [],
      };
    },
  },
};
